type ConfigMap<K extends string | number | symbol, T> = Partial<Record<K, T>>;

export function getConfigForKey<K extends string | number | symbol, T = string>(
    key: K | undefined | null,
    config: ConfigMap<K, T>,
): T | undefined;

export function getConfigForKey<K extends string | number | symbol, T = string>(
    key: K | undefined | null,
    config: ConfigMap<K, T>,
    defVal: T,
): T;

export function getConfigForKey<K extends string | number | symbol, T = string>(
    key: K | undefined | null,
    config: ConfigMap<K, T>,
    defVal?: T,
) {
    if (!key) {
        return defVal;
    }

    return config[key] !== undefined ? config[key] : defVal;
}
